import { KeychainItem } from '../KeychainItem';
/**
 * Returns the response data, along with related keychain items that might be needed to decrypt the data
 */
export class KeychainedResponse {
    constructor(data) {
        this.data = data.data;
        this.keychainItems = data.keychainItems;
    }
    encode(context) {
        if (Array.isArray(this.data)) {
            return {
                data: this.data.map(r => r.encode(context)),
                keychainItems: this.keychainItems.map(r => r.encode(context)),
            };
        }
        return {
            data: this.data.encode(context),
            keychainItems: this.keychainItems.map(r => r.encode(context)),
        };
    }
}
export class KeychainedResponseDecoder {
    constructor(dataDecoder) {
        this.dataDecoder = dataDecoder;
    }
    decode(data) {
        return new KeychainedResponse({
            data: data.field('data').decode(this.dataDecoder),
            keychainItems: data.field('keychainItems').array(KeychainItem),
        });
    }
}
//# sourceMappingURL=KeychainedResponse.js.map